import { BFScreen } from "@/components/standard/screen/BFScreen"
import { SoftCreditPollScreen } from "@/screens/loans/SoftCreditPollScreen"
import { View } from "react-native"
import { H2 } from "@/components/standard/BFText"
import { router, useLocalSearchParams } from "expo-router"

export default function PublicSoftCreditPollScreen() {
  const { loanId } = useLocalSearchParams()

  return (
    <BFScreen
      headerSticky={false}
      dark={false}
      className={"p-5"}
      header={
        <View className={"pt-5 pb-2"}>
          <H2>Soft Credit Pull</H2>
        </View>
      }
    >
      <SoftCreditPollScreen
        defaults={{
          loanId: loanId as string,
        }}
        onSubmit={() => {
          router.replace("./confirmation")
        }}
      />
    </BFScreen>
  )
}
